
import { useParams } from 'react-router-dom';
import { LocalidadesFormState } from '../../../context/localidades/LocalidadesFormState';
import { Form } from './form';

export const LocalidadesFormPage = () => {
  const { id } = useParams();
  const title = id ? "Editar Localidad":"Crear Localidad"

  return (
    <LocalidadesFormState>
        <br />
        <Form title={title} />
    </LocalidadesFormState>
  );
};